module.exports = __webpack_public_path__ + "img/sms.6ec5c376.svg";